/**
 * @author 3173
 * @description 远程认证详情页面配置
 * @Date 2020/8/15
 */
import React from 'react'
import { component_tool, framework_tool,utils_tool } from '@/tool';
import { WizTableForm } from '../../../common'
import moment from "moment";
//import AuthVideo from './authVideo';
import AuthVideo from '../../class/classStudent/classStudentRemoteAuth/authVideo';
import BatchInput from "../../class/classStudent/classStudentRemoteAuth/batchInput";
import { WizNotice } from 'wiz-components';
let { $$, checkStrLength} = utils_tool;
const personInfoConfig = WizTableForm.Config.user(this, { apiParams: { state: 1,positionIdList: ["110"] },path:'personManage/getTeachelist' })
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
}

let { WizModal, WizTimePicker } = component_tool;
const { RangePicker } = WizTimePicker;
let ref_;



//配置项
let componentName = 'studentRemoteAuthDetail'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: '认证日期',
    name: 'openTime',
    searchItem: {
      type: 'date~',
      showTime: false,
      format: 'YYYY-MM-DD'
    }
  },
  {
    title: "学员姓名",
    name: "fullName",
    searchItem: {},
    tableItem: {
      width: 80,
      // render(value, row, index) {
      //   const obj = {
      //     children: value,
      //     props: {},
      //   };
      //   if (index ==0){
      //     obj.props.rowSpan = 2;
      //   }
      //   return obj;
      // }
    },
  },
  {
    title: "学员账号",
    name: "userName",
    searchItem: {},
    tableItem: {
      width: 100
    },
  },
  {
    title: "认证状态",
    name: "authState",
    searchItem: {
      type: 'select'
    },
    dict: [
      { code: 0, codeName: '未开始' },
      { code: 2, codeName: '认证中' },
      { code: 3, codeName: '未参考' },
      { code: 4, codeName: '已完成' },
    //  { code: 6, codeName: '已作废' }
    ],
  },
  {
    title: "经销商简称",
    name: "dealerName",
    searchItem: {},
    tableItem: { width: 120 },
  },
  {
    title: "经销商代码",
    name: "dealerCode",
    searchItem: {},
    tableItem: {width: 150},
  },
  {
    title: "认证场次",
    name: "name",
    searchItem: {
    },
  },
  {
    title: "认证日期",
    name: "authDateStr",
    tableItem: {
      width: 120,
      render: (text, record) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "认证时间",
    name: "startToEndDateStr",
    tableItem: {
      width: 150,
    },
  },
  {
    title: "认证场次",
    name: "name",
    tableItem: {
      width: 180
    },
  },
  {
    title: "认证状态",
    name: "authState",
    dict: [
      { code: 0, codeName: '未开始' },
      { code: 2, codeName: '认证中' },
      { code: 3, codeName: '未参考' },
      { code: 4, codeName: '已完成' },
      { code: 6, codeName: '已作废' }
    ],
    tableItem: {
     // width: 80,
    },
  },
 
];


const templateConfig =(_this)=>{
  return {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck: false,
      searchBarProps: {
        dataFormat: (v) => {
          let value = Object.assign([], v)
          if (value['openTime'] && value['openTime'].length === 2) {
            value['authStartDate'] = moment(value['openTime'][0]).format("YYYY-MM-DD");
            value['authEndDate'] = moment(value['openTime'][1]).format("YYYY-MM-DD");
          }else{
            value['authStartDate'] = undefined;
            value['authEndDate'] = undefined;
          }
          // delete value['openTime']
          return value
        },
        buttonSort: ['resultsGrades','importGrades','export'],
        buttons: [
          {
            key: 'importGrades',
            custom: true,
            params: { icon: 'import', children: '导入成绩', type: 'primary'},
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/remoteAuth/remoteAuthList/studentRemoteAuthDetailList/studentRemoteAuthScoreImport'
              }
            }
          },
          {
            key: 'resultsGrades',
            custom: true,
            needSelect: true,
            params: { children: '发布成绩'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'publishState',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                if (!rows) return;
                if ($$.isArray(rows) && !rows.length) return;
                const content = `您确定要发布这${
                  $$.isArray(rows) ? rows.length : ""
                  }条成绩？`;
                let ids = [];
                let flag = false;
                rows.forEach(e => {
                  if (e['rowKey']) {
                    ids.push(e['rowKey']);
                  }
                  if (e['publishState']!=1){
                    flag = true;
                  }
                });
                if(flag){
                  wizNotice.warn("只可选择可发布状态的学员进行发布成绩,请确认后重试!") 
                  return;
                }
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      idList: ids,
                      publishState: 2
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {  icon: 'export', children: '导出'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        //selectType: "checkbox",
        isScroll: true,
        bordered: true,
        paging: false,
        loading: false,
        maxNum:2
      },
      rowOperateSort: ['enter', 'phoneCall','callLog','videoPlayback','exportStudentGrades'],
      rowOperateView: [
        {
          key: 'phoneCall',
          name: 'WizButton',
          params: {
            children: '拨打电话',
            key: 'phoneCall',
          },
          onClick: (e) => { _this.openCall && _this.openCall(e['record']) }
        },
        {
          key: 'callLog',
          name: 'WizButton',
          params: {
            children: '通话记录',
            key: 'callLog',
          },
          onClick: (e) => { _this.openCallLog && _this.openCallLog(e['record']) }
        },
        {
          custom: true,
          key: 'enter',
          name: 'WizButton',
          params: {
            children: '进入认证',
          },
          customOnClick: {},
          recordChangeParams: ({ record, rows }) => {
            let { authState,showAuth,startDate,endDate,id} = record
            let result = { disabled: true };
            if ( (authState==0 && showAuth) || authState==2) {
              result.disabled = false
            }
            return {
              disabled: result.disabled,
              onClick: () => {
                _this.setState({ selectedRecord : record})
                _this.doAction({
                  path: `studentRemoteAuthDetail/checkStudentRemoteAuthDate`,
                  payload: {
                    key: `studentRemoteAuthDetail@checkStudentRemoteAuthDate`,
                    apiParams: {
                      startDate,
                      endDate,
                      id
                    }
                  }
                })
              },
            }
          }
        },
        // {
        //   key: "videoPlayback",
        //   custom: true,
        //   params: { children: "录像回放"},
        //   customOnClick: {
        //     key: "modal",
        //     params: {
        //       modalKey: "playbackModal",
        //       modalParams: {
        //         title: "录像回放",
        //         diy: (e) => {
        //           e.record = Object.assign({}, e.record);
        //           return (
        //             <AuthVideo
        //               key={'authVideo-'+e.record.id}
        //               {...e}
        //               type={0}
        //               ref={r => {
        //                 ref_ = r && r.getWrappedInstance();
        //               }}
        //             />
        //           )
        //         },
        //         footer:null,

        //         width: 700
        //       }
        //     },
        //     formatParams: (rows, record, filter) => {
        //       return { ...record };
        //     }
        //   },
        //   // recordChangeParams: (record, rows) => {
        //   //   let result = { disabled: true };
        //   //   if (record.record && record.record.publishState > 0 && record.record.publishState!=3) {
        //   //     result.disabled = false
        //   //   }
        //   //   return result
        //   // },
        // },
        {
          key: "exportStudentGrades",
          custom: true,
          params: { children: "导出成绩" },
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'exportStudentAchievement'
            },
            formatParams: (rows, record, filters, callback) => {
              let { id,remoteAuthId ,personId} = record
              callback && callback({
                studentRemoteAuthDetailId: id,
                remoteAuthId: remoteAuthId,
                personId:personId
              })
              return null
            }
          },
          recordChangeParams: (record, rows) => {
            let result = { disabled: true };
            if (record.record && record.record.authState == 4) {
              result.disabled = false
            }
            return result
          },
        },
      ]
    }
  }
}
};

let reduxTemplateCofig = (args) => {
  let {remoteAuthId,user }= args;
  let personId = user.personId == "1cdf270fdc764dfb91634d3b2f48257f" ? null : user.personId
  const apis = {
    list: {
      path: `${componentName}/listForTeacher`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1 , videoTool : 2,lectureId:personId}
      }
    },
    publishState: {
      path: `${componentName}/publishStateRe`,
      payload: {
        key: `${componentName}@publishState`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/exportForTeacher`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {remoteAuthId : remoteAuthId ? remoteAuthId : null , type:1 , videoTool : 2,lectureId:personId}
      }
    },
    exportStudentAchievement: {
      path: `${componentName}/exportStudentAchievement`,
      payload: {
        key: `${componentName}@exportStudentAchievement`,
        apiParams: {}
      }
    }
    
  }
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
